import { Skeleton } from '@dreamtree-org/twreact-ui';
import { QueryState } from '@/components';
import { useStorefront } from '../StorefrontContext';

export function SkeletonGrid({ count = 4 }) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3 xl:grid-cols-4" aria-busy="true">
      {Array.from({ length: count }, (_, i) => <Skeleton key={i} height={260} />)}
    </div>
  );
}

/**
 * Loading (skeleton) / error (QueryState with retry) / ready switch for the
 * real catalog every storefront page shares.
 */
export default function CatalogGate({ children, skeleton = <SkeletonGrid /> }) {
  const { catalog } = useStorefront();
  if (catalog.error) return <QueryState query={catalog}>{() => null}</QueryState>;
  if (!catalog.data) return skeleton;
  return children;
}
